"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var styled_system_1 = require("styled-system");
var Core = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"])), styled_system_1.space, styled_system_1.width, styled_system_1.color, styled_system_1.fontSize, styled_system_1.display);
Core.displayName = "Core";
exports.default = Core;
var templateObject_1;
